/**
 * APP: Taako.
 *
 * Intro
 * Uses the Screen ResizeContext
 *
 */

import React from 'react';
import './Intro.css';
import TweenMax from 'gsap/TweenMax';
import 'gsap/CSSPlugin';

import constants from './Constants'
import parser from 'ua-parser-js'

const ua = new parser();

class Intro extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isProduction: constants.IS_PRODUCTION,
      sw: 0,
      sh: 0,
      fontSize: 0,
      ua: ua.getResult()
    };
  }

  componentDidMount() {
    TweenMax.to("#intro-preloader", .75, {opacity:'0', delay: 1, display:'none', onComplete:this.fadeInCTA});
  }

  // Deal with screen resize in Intro
  static getDerivedStateFromProps(nextProps, prevState) {
    if ( prevState.sw !== nextProps.sw ||
         prevState.sh !== nextProps.sh ) {
      return {
        sw: nextProps.sw,
        sh: nextProps.sh,
        fontSize: 18
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if ( this.state !== nextState ) {
      return true
    } else {
      return false
    }
  }

  introStart = () => {

    if ( window.Modernizr.audio && window.Modernizr.webgl && window.Modernizr.canvas ) {
      TweenMax.to("#brand-logo-2nd", 0.5, { opacity:1 });
      TweenMax.to("#preloader-subcopy", 0.5, { opacity:1, delay:.25 });
    } else {
      let el = document.getElementById('capabilities-container');
        el.style.display = 'block';
        TweenMax.to("#brand-logo-2nd", 0.5, { opacity:1 });
        TweenMax.to("#capabilities-container", 0.5, {opacity:1, delay:.25});
    }
  }

  introEnd = () => {
    TweenMax.to("#backgroundGradient", .250, {opacity:1});
    // TweenMax.to("#intro-content-anim", .75, {opacity:0});
    // TweenMax.to("#intro-preloader", 1, {opacity:1, delay: .5, onComplete:this.closeIntro});
    TweenMax.to("#preloader-subcopy", 0.5, { opacity:0, display:'none', onComplete:this.showLoader});
  }

  showLoader = () => {
    let el = document.getElementById('inner-preloader-gif');
    el.style.opacity = '0';
    el.style.display = 'inline';
    TweenMax.to("#inner-preloader-gif", .5, {opacity:1, onComplete:this.hideIntro});
  }

  closeIntro = () => {
    TweenMax.to("#intro-container", 0, { opacity: 0, display:'none', onComplete:this.hideIntro});
  }

  hideIntro = () => {
    // let el = document.getElementById("intro-container");
    //     el.style.display = "none !important";
    this.props.introComplete( true );
  }

  fadeInCTA = () => {
    this.introStart();
  }

  render() {
    return (
      <div id="intro-container" className="intro-container">

        <div className="intro-centering">
          <div id={"intro-content-anim"} className={"intro-content"}>

            <div className={"set-fixed-height"}>
              <img id={"brand-logo-2nd"} width="225" height="99" src="./taako-logo-small.png" alt="" style={{opacity:0, position:'relative',left:'-3px'}}/>
              <br />
              <img id="inner-preloader-gif" src="./loadstone.gif" alt=""/>
              <div id={"preloader-subcopy"} style={{opacity:0}}>
                <h1 className={"cta-pink noselect"} onClick={this.introEnd}>
                  <span>{ constants.LAYER_COPY.intro.firstScreenHeader }</span>
                </h1>
                <br />
                <h1 className={"cta-subheading"}>
                  { constants.LAYER_COPY.intro.firstScreenHeaderLine2 }
                </h1>
              </div>
            </div>

            <div id={"capabilities-container"} className={"capabilities-container"}>
              <p className={"capabilities-description"}>
                The Virtual Stone of Farspeech is not supported by this device.
                Interfacing with the Farspeech Network over an internet connection requires
                a basic affinity for magick in addition to an internet browser that supports
                WebGL. This browser does not support the following technology:</p>
                <div className={"tech-container"}>
                  <p>webGl</p>
                  <p>canvas</p>
                  <p>audio</p>
                </div>
              </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/Intro.js